var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwRuleBreakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.627 175.033C317.679 259.905 243.688 324.03 158.526 324.03H10.254C6.19177 324.03 3 320.838 3 316.776V178.225C3 83.3421 67.1254 9.35117 151.997 3.40288C249.636 -3.41589 330.301 77.2487 323.482 174.888L323.627 175.033Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.475 266.434C221.284 266.434 267.337 220.381 267.337 163.572C267.337 106.763 221.284 60.71 164.475 60.71C107.666 60.71 61.6133 106.763 61.6133 163.572C61.6133 220.381 107.666 266.434 164.475 266.434Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.314 163.572C194.645 180.256 181.007 193.749 164.323 237.563C147.639 193.894 134.146 180.256 90.332 163.572C134.001 146.888 147.639 133.395 164.323 89.5811C181.007 133.25 194.5 146.888 238.314 163.572Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.469 192.444C180.414 192.444 193.34 179.518 193.34 163.573C193.34 147.628 180.414 134.702 164.469 134.702C148.524 134.702 135.598 147.628 135.598 163.573C135.598 179.518 148.524 192.444 164.469 192.444Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.663 3.11328H10.254C6.24773 3.11328 3 6.36101 3 10.3673V316.777C3 320.783 6.24773 324.031 10.254 324.031H316.663C320.67 324.031 323.917 320.783 323.917 316.777V10.3673C323.917 6.36101 320.67 3.11328 316.663 3.11328Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwRuleBreakers);
export default __webpack_public_path__ + "static/media/dfw-Rule-breakers.10b398815f030d2368c1f1edcc647820.svg";
export { ForwardRef as ReactComponent };